import {useNavigate, useSearchParams} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import MDBox from "../../components/MDBox";
import {CompanyContext} from "../../lib/CompanyProvider";
import {MenuContext} from "../../lib/MenuProvider";
import {bookedTimeBlock, formatDateMask, formatDateTimeTz, urlSearchParams, validEvent} from "../common/Utils";
import Box from "@mui/material/Box";
import {addDays} from "@fullcalendar/core/internal";
import dayjs from "dayjs";
import {CalendarIcon, DatePicker} from "@mui/x-date-pickers";
import MDButton from "../../components/MDButton";
import {Grid} from "@mui/material";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function PortalCalendar({
                                         events,
                                         partyView,
                                         handleDatesSet,
                                         eventClick,
                                         eventTypesFilter,
                                         ageTypeFilter
                                       }) {
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [menuContext, setMenuContext] = useContext(MenuContext);
  const navigate = useNavigate();
  const [pageReady, setPageReady] = useState(false);
  const [calendarDate, setCalendarDate] = useState();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (companyContext?.company?.guid) {
      setPageReady(true);
    }
  }, [companyContext?.company]);

  const showEvent = (_event) => {
    let show = (eventTypesFilter.length === 0 || eventTypesFilter.indexOf(_event?.eventType?.id) > -1);
    show = show && (ageTypeFilter.length === 0 || ageTypeFilter.indexOf(_event?.ageRange?.id) > -1);
    return show;
  };

  const filteredEvents = (events) => {
    let _events = [];
    for (let j in events) {
      if (showEvent(events[j])) {
        _events.push(events[j]);
      }
    }
    setEventsFiltered(_events);
  }

  const [eventsFiltered, setEventsFiltered] = useState();
  useEffect(() => {
    if (!events) {
      return;
    }
    filteredEvents(events);
  }, [events])

  useEffect(() => {
    if (!events) {
      return;
    }
    filteredEvents(events);
  }, [eventTypesFilter, ageTypeFilter]);

  const stickyCell = {
    position: "sticky",
    left: 0,
    zIndex: 2,
    backgroundColor: "#fff",
    borderRight: "1px solid #e0e0e0",
    borderBottom: "1px solid #e0e0e0",
    padding: "12px",
    boxShadow: "2px 0 4px rgba(0,0,0,0.06)", // visual overlap hint
  };

  const stickyWidth = 75;

  const stickyHeaderCell = {
    ...stickyCell,
    fontWeight: "bold",
    top: 0,
    width: `${stickyWidth}px`,
    left: '-1px',
    outline: 'solid 2px #fff',
    zIndex: 3,
  };

  const headerCell = {
    backgroundColor: "#fafafa",
    borderBottom: "1px solid #e0e0e0",
    padding: "6px",
  };

  const maxRows = () => {
    let mmm = 1;
    for (let [k, v] of eventMap) {
      if (v?.length > mmm) {
        mmm = v?.length;
      }
    }
    return mmm + 1;
  }

  const [inventoryRender, setInventoryRender] = useState(1);
  const [calendarEvents, setCalendarEvents] = useState([]);

  const [eventMap, setEventMap] = useState(new Map());

  useEffect(() => {
    if (!eventsFiltered) {
      return;
    }
    const map = new Map();
    for (const _e in eventsFiltered) {
      try {
        let d = dayjs(eventsFiltered[_e].eventDate)
          .tz(companyContext?.timeZone).toDate();
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);
        let key = d.getTime();
        if (!map.has(key)) {
          map.set(key, []);
        }
        map.get(key).push(eventsFiltered[_e]);
      } catch (err) {
        console.dir(err);
      }
    }
    setEventMap(map);
  }, [eventsFiltered])

  const shortDay = (date) => {
    if (!date) {
      return '';
    }
    let d = dayjs
      .utc(date)
      .tz(companyContext?.timeZone).toDate();
    return new Intl.DateTimeFormat("en-US", {
      weekday: "short",
    }).format(d);
  }


  const displayAgendaDay = (timestamp) => {
    const _d = new Date(timestamp);
    return <div>
      <span style={{
        fontSize: '0.85rem'
      }}>
        {shortDay(_d)}
      </span>
      <br/>
      <span style={{
        fontSize: '1.05rem'
      }}>
        {formatDateMask(_d, 'DD')}
      </span>
    </div>
  }

  useEffect(() => {
    if (!calendarDate) {
      return;
    }
    let now = new Date(calendarDate);
    const info = {
      start: now.toISOString(),
      end: addDays(now, 30).toISOString(),
    }
    handleDatesSet(info)
  }, [calendarDate])

  useEffect(() => {
    let d = dayjs(calendarDate)
      .tz(companyContext?.timeZone).toDate();
    setCalendarDate(d);
  }, []);

  const updateAgendaDates = (date) => {
    setCalendarDate(date);
  }

  return (
    <>
      {pageReady && <MDBox sx={{
        width: '100%',
        maxWidth: '100vw',
      }}>

        <Grid container spacing={2}>
          <Grid item>
            <DatePicker
              sx={{
                borderRadius: '0',
                marginBottom: '8px',
                '& .MuiInputBase-root': {
                  borderRadius: '0',
                },
              }}
              slotProps={{
                actionBar: {
                  actions: ['today', 'accept'],
                },
              }}
              value={dayjs(calendarDate)
                .tz(companyContext?.timeZone)}
              onChange={(e) => {
                updateAgendaDates(new Date(e.$d));
              }}
            />
          </Grid>
          <Grid item justifyContent={'flex-end'}>

            <span className="d-inline-block">
                        <MDButton
                          sx={{
                            borderRadius: "0",
                          }}
                          color="primary"
                          onClick={() => {
                            if (partyView) {
                              navigate('/cx/parties' + (urlSearchParams('eventType', searchParams.get('eventType'), '?')));
                            } else {
                              navigate('/cx/events' + (urlSearchParams('eventType', searchParams.get('eventType'), '?')));
                            }
                          }}>
                        <CalendarIcon/>&nbsp;
                          List View
                      </MDButton>
                    </span>
          </Grid>
        </Grid>

        <Box
          sx={{
            width: "100%",
            overflowX: "auto",
            WebkitOverflowScrolling: "touch",
            marginBottom: '50px'
          }}
        >
          {[...eventMap.entries()]
            .sort(([a], [b]) => {
              if (a < b) return -1;
              if (a > b) return 1;
              return 0;
            }).map(([key, value], idx) => {
              return (
                <Box key={idx}
                     sx={{
                       display: "grid",
                       gridTemplateColumns: `${stickyWidth}px repeat(${maxRows()}, minmax(120px, 1fr))`,
                       minWidth: `${maxRows() * 120}px`,
                     }}>
                  <Box sx={stickyHeaderCell} style={{
                    textAlign: 'center',
                    border: 'solid 1px #ddd',
                  }}>
                    {displayAgendaDay(key)}
                  </Box>

                  {value.sort((a, b) => new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime()).map((col, idx) => (
                    <Box key={idx} sx={headerCell} style={{
                      textAlign: 'left',
                      border: 'solid 1px #ddd',
                      backgroundColor: col.eventType?.backgroundColor || 'inherit',
                      fontColor: col.eventType?.fontColor || 'inherit',
                      opacity: validEvent(col) ? '1' : '0.6',
                      informational: col.eventType?.eventTypeInformational
                    }} onClick={(e) => {
                      eventClick(col)
                    }}>
                      <p style={{
                        color: col.eventType?.fontColor || 'inherit'
                      }}>
                        <b>{col.name}</b><br/>
                        {col?.timeBlockParent && <span>Multiple times</span>}
                        {!col?.timeBlockParent && companyContext?.timeZone &&
                          <span>{formatDateTimeTz(col.eventDate, 'h:mm a', companyContext?.timeZone)}</span>}
                        {col.bookedFull && <><br/>Booked Full</>}
                        {!col.bookedFull && !validEvent(col) && <><br/>Registration Closed</>}
                      </p>
                    </Box>
                  ))}
                </Box>
              )
            })
          }
        </Box>

      </MDBox>
      }
    </>
  )
}